/**
 * 레퍼런스(wiki) : https://podotree.atlassian.net/wiki/spaces/PSD/pages/2737275008/TicketType
 * 레퍼런스(api) : https://github.kakaocorp.com/kakaopage/api/blob/e7534bc8aa9241bd92cf046410ceed0bdb77268b/common/src/main/java/com/kakaopage/common/model/enums/TicketType.java
 */

export enum TicketTypeVo {
  BuyNewCustomerGift = 'TT00', // 신규 고객 혜택
  BuySingle = 'TT01', // 단일 이용권
  BuyPackage = 'TT02', // 시리즈 이용권 패키지
  BuyEvent = 'TT03', // 이벤트 발급 이용권 - 사용자에게 즉시 지급되지 않음 - 작품홈 진입시 (NEXT 기준)
  BuyCoupon = 'TT04', // 쿠폰 발급 이용권
  BuyWaitFree = 'TT05', // 기다리면 무료 소장 이용권 - 정의만 되어 있고 사용되지 않음
  BuyTodayGift = 'TT06', // 오늘의 선물 소장 이용권
  BuyGiftFree = 'TT07', // 선물하면 무료 소장 이용권 - 선물무 기능이 종료되어 현재 사용되지 않음
  BuyMoviePpv = 'TT08', // 즉납형 소장 이용권 - 현재 사용되고 있지 않음
  BuyCampaign = 'TT09', // 리워드 소장 이용권
  /** @deprecated */
  BuyWaitFreePlus = 'TT10', // 레전드패스(기다리면 무료 플러스) 소장 이용권
  BuyCashSingle = 'TT11', // 즉납형 단일 소장권 (캐시타입)
  BuyCashDiscountSingle = 'TT12', // 즉납형 할인 단일 소장권 (캐시타입)
  BuySet = 'TT13', // 세트 소장권 패키지
  RentNewCustomerGift = 'RT00', // 신규 대여 고객 혜택
  RentSingle = 'RT01', // 단일 대여 이용권
  RentPackage = 'RT02', // 시리즈 대여 이용권 패키지
  RentEvent = 'RT03', // 이벤트 발급 대여 이용권 - 사용자에게 즉시 지급되지 않음 - 작품홈 진입시 (NEXT 기준)
  RentCoupon = 'RT04', // 쿠폰 발급 대여 이용권
  RentWaitFree = 'RT05', // 기다리면 무료 대여 이용권
  RentTodayGift = 'RT06', // 오늘의 선물 대여 이용권
  RentGiftFree = 'RT07', // 선물하면 무료 대여 이용권
  RentMoviePpv = 'RT08', // 즉납형 대여 이용권
  RentCampaign = 'RT09', // 리워드 대여 이용권
  /** @deprecated */
  RentWaitFreePlus = 'RT10', // 레전드패스(기다리면 무료 플러스) 대여 이용권
  RentCashSingle = 'RT11', // 즉납형 단일 대여권 (캐시타입)
  RentCashDiscountSingle = 'RT12', // 즉납형 할인 단일 대여권 (캐시타입)
  RentSet = 'RT13', // 세트 대여권 패키지
  WebSeries = 'ST01', // 연재 예정작 이용권
  /**
   * 스펙 아웃된 이용권으로 환불을 제외한 서비스 로직에서 제거됨
   */
  Premium = 'UT01', // 프리미엄 이용권
  Deactivate = 'ET99', // 비활성 이용권
}
